import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';
import {
  ConfiguracionFormulario,
  DisplayFormulario,
  PosicionLabelFormulario,
  TipoCampoFormulario,
} from 'src/app/compartido/formulario/utilidades/formulario.models';
import { Icono } from 'src/app/compartido/utilidades/compartido.static';
import { formatearFecha } from 'src/app/compartido/utilidades/valores.utils';
import { DetalleTareaDia, TareaDia } from './tareas-dia.models';
import { Permiso } from 'src/app/nucleo/autorizacion/autorizacion.models';
import { ConfiguracionDialogoFormulario } from 'src/app/compartido/dialogos/dialogo-formulario/utilidades/dialogo-formulario.static';

/* Configuración de la ficha de tareas del dia */
export const CONFIGURACION_FICHA_TAREAS_DIA: ConfiguracionFicha = {
  contenido: { padding: true },
  header: { titulo: 'Tareas del Día', icono: Icono.TAREAS_DIA },
};

/* Configuración del formulario de tareas del dia */
export const CONFIGURACION_FORMULARIO_TAREAS_DIA: ConfiguracionFormulario = {
  campos: [
    {
      nombre: 'Fecha',
      slug: 'fecha',
      tipo: TipoCampoFormulario.FECHA,
      requerido: true,
      valor: formatearFecha(new Date()),
      maximo: formatearFecha(new Date()),
    },
    {
      nombre: 'Organización',
      slug: 'organizacion',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: [], // Se obtiene del servidor
      requerido: true,
    },
  ],
  estilo: { esconderErrores: true },
};

/* Detalles de las tareas de preparación */
export const DETALLES_TAREAS_DIA: DetalleTareaDia[] = [
  {
    // CASO ESPECIAL: Evedisa Pereira
    slug: TareaDia.MIPRES,
    nombre: 'Moléculas Mipres',
    icono: Icono.MEDICAMENTO,
    descripcion:
      'Debes revisar si las moléculas de la fórmula necesitan documentación adicional Mipres',
    estadisticas: [],
  },
  {
    slug: TareaDia.CREACION,
    nombre: 'Crear Órdenes',
    icono: Icono.CREAR_ORDEN,
    descripcion:
      'Debes importar las órdenes del día mediante un archivo Excel o CSV',
    estadisticas: [{ slug: 'creadas', nombre: 'Creadas', color: 'primario' }],
  },
  {
    slug: TareaDia.PREPARACION,
    nombre: 'Preparar Órdenes',
    icono: Icono.PREPARACION,
    descripcion:
      'Debes preparar las órdenes del día para entregarlas al transportista',
    estadisticas: [
      {
        slug: 'pendientes',
        nombre: 'Pendientes',
        color: 'accent',
        ocultarPasado: true,
      },
      { slug: 'preparadas', nombre: 'Preparadas', color: 'primario' },
      { slug: 'rechazadas', nombre: 'Rechazadas', color: 'warn' },
    ],
  },
  {
    slug: TareaDia.ETIQUETAS,
    nombre: 'Imprimir Etiquetas',
    icono: Icono.ETIQUETAS,
    descripcion:
      'Debes imprimir y adjuntar las etiquetas de las órdenes del día a sus paquetes',
    estadisticas: [
      { slug: 'pendientes', nombre: 'Pendientes', color: 'accent' },
      { slug: 'generadas', nombre: 'Generadas', color: 'primario' },
      { slug: 'sin_domicilio', nombre: 'Sin Domicilio', color: 'warn' },
    ],
    botonPasado: true,
  },
  {
    slug: TareaDia.RECOGIDA,
    nombre: 'Recoger Órdenes',
    icono: Icono.RECOGIDA,
    descripcion: 'Debes recoger las órdenes del día en la farmacia',
    estadisticas: [
      {
        slug: 'pendientes',
        nombre: 'Pendientes',
        color: 'accent',
        ocultarPasado: true,
      },
      { slug: 'recogidas', nombre: 'Recogidas', color: 'primario' },
    ],
  },
  {
    slug: TareaDia.PLANILLA_RECOGIDA,
    nombre: 'Planilla de Recogida',
    icono: Icono.PLANILLA,
    descripcion:
      'Debes imprimir la planilla de las órdenes recogidas por el transportista',
    estadisticas: [
      {
        slug: 'por_recoger',
        nombre: 'Por Recoger',
        color: 'accent',
        ocultarPasado: true,
      },
      { slug: 'pendientes', nombre: 'Por Planillar', color: 'accent' },
      { slug: 'planilla', nombre: 'En Planilla', color: 'primario' },
    ],
    botonPasado: true,
  },
  {
    slug: TareaDia.ENRUTAMIENTO,
    nombre: 'Enrutar Domicilios',
    icono: Icono.ENRUTAMIENTO,
    descripcion:
      'Debes asignarle una ruta a los domicilios del día en SimpliRoute',
    estadisticas: [
      {
        slug: 'pendientes',
        nombre: 'Pendientes',
        color: 'accent',
        ocultarPasado: true,
      },
      { slug: 'enrutados', nombre: 'Con Ruta', color: 'primario' },
    ],
  },
  {
    slug: TareaDia.DESPACHO,
    nombre: 'Despachar Domicilios',
    icono: Icono.DESPACHO,
    descripcion:
      'Debes despachar los domicilios con ruta asignada para su entrega',
    estadisticas: [
      {
        slug: 'pendientes',
        nombre: 'Pendientes',
        color: 'accent',
        ocultarPasado: true,
      },
      { slug: 'despachados', nombre: 'Despachados', color: 'primario' },
    ],
  },
  {
    slug: TareaDia.ENTREGA,
    nombre: 'Entregar Domicilios',
    icono: Icono.ENTREGA,
    descripcion: 'Debes entregar los domicilios en el domicilio del cliente',
    estadisticas: [
      {
        slug: 'pendientes',
        nombre: 'Pendientes',
        color: 'accent',
        ocultarPasado: true,
      },
      { slug: 'entregados', nombre: 'Entregados', color: 'primario' },
      { slug: 'fallidos', nombre: 'Fallidos', color: 'warn' },
    ],
  },
  {
    slug: TareaDia.LEGALIZACION,
    nombre: 'Legalizar Domicilios',
    icono: Icono.LEGALIZACION,
    descripcion: 'Debes verificar los domicilios completados en el día',
    estadisticas: [
      {
        slug: 'pendientes',
        nombre: 'Pendientes',
        color: 'accent',
        ocultarPasado: true,
      },
      { slug: 'legalizados', nombre: 'Legalizados', color: 'primario' },
    ],
  },
];

/* Configuración dialogo de planilla de recogida */
export const CONFIGURACION_DIALOGO_PLANILLA_RECOGIDA: ConfiguracionDialogoFormulario =
  {
    titulo: 'Seleccionar punto de origen',
    formulario: {
      campos: [
        {
          nombre: 'Organización',
          slug: 'organizacion',
          tipo: TipoCampoFormulario.OPCION_MULTIPLE,
          opciones: [],
          oculto: true,
        },
        {
          nombre: 'Punto de Origen',
          slug: 'origen',
          tipo: TipoCampoFormulario.OPCION_MULTIPLE,
          opciones: [],
        },
      ],
      estilo: {
        posicionLabel: PosicionLabelFormulario.TOP,
        display: DisplayFormulario.GRID,
      },
    },
    botonPrincipal: 'Confirmar',
    botonSecundario: 'Cancelar',
  };
